import { EnvironmentService } from './environment.service';

export const platformClientHeaders = {
  'X-App-PlatformClient': EnvironmentService.getVariable('PLATFORM_CLIENT'),
};
